import * as React from 'react';
import {Box, FsH1, FsH2, FsH3, FsH4 } from '@aviatrix/flights';

import {
  ImgAvxLogo,
} from './pages/components/SVGIcons';


const Template = (props:any)=>{
  return (
    <Box className={`container default`} 
      sx={{gap:17}}
    >
      {props.children}
      
      <Box className='right-section' style={{textAlign:'center'}}>  
          <Box className='line'> </Box>
          <Box className='logo-section'>
            <Box className='logo'>
              <FsH1 fontWeight={700} paddingBottom={2} paddingLeft={'76px'} textAlign={'left'} color='aviatrix.main' >LAUNCH  </FsH1>
              <img src={ImgAvxLogo}/>
              <FsH3 fontWeight={400} paddingTop={2} paddingLeft={'76px'}  textAlign={'left'} color='aviatrix.dark' >Enterprise  </FsH3>
            </Box>
          </Box>
          <Box className='line'> </Box>
      </Box>

    </Box> 
  )
}

export default Template;
